import React from "react";
import ForgotPassword from "../../components/ForgotPassword/ForgotPassword";

const ForgotPasswordPage = () => {
  return (
    <div>
      <div className="min-h-screen">
        <br />
        <br />
        <ForgotPassword />
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
